'use strict';

/* Views */
import BusinessProfile from './profile/business-profile.component';

/* Services */
import BusinessService from '../../services/business/business.service';

export default angular.module('conduuApp.business', [BusinessProfile, BusinessService])
  .name;



// WEBPACK FOOTER //
// ./client/app/business/index.js